import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import Tramite from '@/components/pages/Tramite';
import Solicitud from '@/components/pages/Solicitud';
import Contactos from '@/components/pages/Contactos';
import Seguimiento from '@/components/pages/Seguimiento';
// import Verificar from '@/components/pages/Verificar';
// import Contacto from '@/components/pages/Contacto';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/tramite',
      name: 'Tramite',
      component: Tramite
    },
    {
      path: '/solicitud',
      name: 'Solicitud',
      component: Solicitud
    },
    {
      path: '/seguimiento',
      name: 'Seguimiento',
      component: Seguimiento
    },
    {
      path: '/contactos',
      name: 'Contactos',
      component: Contactos
    }
    /* {
      path: '/verificar',
      name: 'Verificar',
      component: Verificar
    },
    {
      path: '/contacto',
      name: 'Contacto',
      component: Contacto
    } */
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js